module.exports = __webpack_public_path__ + "img/LX_BLACK.c6a2f3a5.png";